import React from 'react';
import {
	Box,
	IconButton,
	List,
	ListItem,
	ListItemText,
	Modal,
	Paper,
	Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import { localDateFormat } from '../../helpers/hours';
import { AREA_COLORS } from '../utils/lists';

export const DateModal = ({ dateData, openModal, handleCloseModal }) => {
	const modalStyle = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		height: `${dateData?.events?.length <= 4 ? '60' : '80'}%`,
		transform: 'translate(-50%, -50%)',
		width: 500,
		bgcolor: 'background.paper',
		border: '2px solid #000',
		boxShadow: 24,
		p: 4,
		overflowY: 'scroll',
	};

	return (
		<Modal
			open={openModal}
			onClose={handleCloseModal}
			aria-labelledby='modal-title'
			aria-describedby='modal-description'
		>
			<Box sx={modalStyle}>
				<IconButton
					style={{ position: 'absolute', top: '8px', right: '8px' }}
					onClick={handleCloseModal}
				>
					<CloseIcon />
				</IconButton>
				{dateData && (
					<>
						<Typography variant='h6' id='modal-title' gutterBottom>
							Lista del trabajo del día.
						</Typography>
						<Typography variant='body1' id='modal-description'>
							Fecha: {localDateFormat(dateData.date)}
						</Typography>
						<Box>
							<Typography variant='h6' gutterBottom mt={2}>
								Eventos:
							</Typography>
							<Paper elevation={3}>
								<List>
									{dateData.events.map(
										({ color, extendedProps }, index) => {
											const { key: biasKey, areas } =
												extendedProps.bias;
											let area = AREA_COLORS.find(
												(x) => x.color === color
											).area;
											area = areas[area];
											return (
												<ListItem
													key={`${biasKey}-${index}`}
												>
													<ListItemText
														primary={
															<span>
																<b>{`• ${biasKey}: `}</b>
																{`${
																	area?.name ||
																	'-'
																}`}
															</span>
														}
														secondary={`Días: ${
															area?.days || '-'
														}`}
													/>
												</ListItem>
											);
										}
									)}
								</List>
							</Paper>
						</Box>
					</>
				)}
			</Box>
		</Modal>
	);
};
